import { render, staticRenderFns } from "./Pdd.vue?vue&type=template&id=71416be6&"
import script from "./Pdd.vue?vue&type=script&lang=js&"
export * from "./Pdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports